import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIsMount } from '@yme/common/hooks';
import { getIsInAuthor, getRootLang } from '@yme/selectors/index';
import { getDataForDestinationCard } from '../UnitRelatedExperience/helpers';
import { getRelatedExperiences } from '../redux/selectors';
export function useRelatedExperiences(edpURL) {
    const [destinations, setDestinations] = useState([]);
    const relatedExperiences = useSelector(getRelatedExperiences);
    const language = useSelector(getRootLang);
    const isInAuthor = useSelector(getIsInAuthor);
    const isMount = useIsMount();
    useEffect(() => {
        if (!relatedExperiences.length || isMount)
            return;
        const getDataForRelatedExperiences = async () => {
            try {
                const destinationData = relatedExperiences.map((destination) => getDataForDestinationCard(destination, language, edpURL, isInAuthor));
                setDestinations(destinationData);
            }
            catch (error) {
                console.error(error);
            }
        };
        getDataForRelatedExperiences();
    }, [isInAuthor, language, relatedExperiences, edpURL, isMount]);
    return destinations;
}
